import { Button, Col, Modal, Row } from "antd"


interface IModalExitoso {
    openModal: boolean,
    setOpenModal: Function,
    setOpenModalAnterior?: any
    getLineasConvocatorias: Function
}

export const ModalExitoso = ({ openModal, setOpenModal, setOpenModalAnterior, getLineasConvocatorias } : IModalExitoso) => {

    const onCancel = () => setOpenModal(!openModal);

    const redirectScreen = () => {
        onCancel();
        setOpenModalAnterior(false);
        getLineasConvocatorias();
    }

    return (
        <Modal
            visible={ openModal }
            onCancel={ onCancel }
            footer={
                <Row justify="center">
                    <Button className="button-azul-radius" onClick={ redirectScreen  }>
                        Aceptar
                    </Button>
                </Row>
            }
        >
            <Row style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <Col className="font-size-22px font-family-Montserrat-SemiBold" style={{color: '#2F7E05'}}>
                    Proceso exitoso
                </Col>
                <Col className="font-size-14px font-family-Work-Sans font-color-1B1C1D">
                    Los cambios se han guardado exitosamente
                </Col>
            </Row>
        </Modal>
    )
}
